import styled from 'styled-components'

export const errorMsgFontSize = '12px'
export const defaultErrorMsgFixedHeight = '16px'

export const FormFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
`